import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '奶片动漫 - 正版动漫在线观看平台',
  description: '奶片动漫是你的专属动漫追番基地，涵盖热门新番、经典老番、国漫、日漫等海量资源',
  url: 'https://naipiananime.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '奶片动漫',
    url: 'https://naipiananime.com',
  },
  mainEntity: {
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '奶片动漫可以免费观看吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '奶片动漫提供大量免费动漫资源，部分最新番剧和新番抢先看可能需要会员权限。',
        },
      },
      {
        '@type': 'Question',
        name: '支持哪些设备观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '奶片动漫支持PC网页端、移动端网页以及平板设备观看。只需浏览器即可访问。',
        },
      },
      {
        '@type': 'Question',
        name: '新番更新速度怎么样？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '热门新番通常在日本播出后的24小时内完成翻译并上线。',
        },
      },
      {
        '@type': 'Question',
        name: '如何查找我想看的动漫？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过搜索或按分类浏览找到感兴趣的内容。',
        },
      },
      {
        '@type': 'Question',
        name: '画面卡顿或加载慢怎么办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '建议检查网络连接或尝试切换播放清晰度。奶片动漫采用CDN加速技术确保流畅播放。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系客服？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过关于我们页面找到联系方式，客服团队将在24小时内回复。',
        },
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        schema={homeSchema}
      />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <ArticlesSection />
        <FAQSection />
      </main>
    </>
  );
}